import { render } from "./Boost.vue?vue&type=template&id=326c4035&scoped=true"
import script from "./Boost.vue?vue&type=script&lang=js"
export * from "./Boost.vue?vue&type=script&lang=js"

import "./Boost.vue?vue&type=style&index=0&id=326c4035&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326c4035"]])

export default __exports__